import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { 
  Login, 
  Signup, 
  ForgotPassword,
  ResetPassword,
  Dashboard, 
  Home,
  Members, 
  Profile, 
  Support, 
  PlansAndBilling, 
  ApiKeys,
  ApplicationParticipants,
  ApplicationAgents,
  ApplicationSettings,
  Documentation,
  NotFound404
} from '../pages';
import PrivacyPolicy from '../pages/privacy/PrivacyPolicy';
import TermsAndConditions from '../pages/terms/TermsAndConditionsPage';
import AIEmployee from '../pages/ai-employee/AIEmployee';
import InactiveUserRequests from '../pages/developer/InactiveUserRequests';

import RoleRoute from './RoleRoute';
import ChatSettingsScreen from '../pages/settings/ChatSettings';
import CallSettingsScreen from '../pages/settings/CallSettings';
import SentimentAggregateAnalytics from '../pages/dashboard/SentimentAggregateAnalytics';
import SentimentParticipantAnalytics from '../pages/dashboard/SentimentParticipantAnalytics';
import SentimentCallAnalytics from '../pages/dashboard/SentimentCallAnalytics';
import CallRecordingsScreen from '../pages/recordings/CallRecordings';
import ChatBot from '../pages/bots/ChatBot';
import AIChatBot from '../pages/bots/AIChatBot';
import AgentChats from '../pages/agents/AgentChats';
import GetStartedIntegrate from '../pages/get-started/GetStartedIntegrate';
import WidgetBuilder from '../pages/get-started/WidgetBuilder';

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<RoleRoute><Dashboard /></RoleRoute>} />
        <Route path="/sentiment-call-analytics" element={<RoleRoute><SentimentCallAnalytics /></RoleRoute>} />
        <Route path="/sentiment-participant-analytics" element={<RoleRoute><SentimentParticipantAnalytics /></RoleRoute>} />
        <Route path="/sentiment-aggregate-analytics" element={<RoleRoute><SentimentAggregateAnalytics /></RoleRoute>} />
        <Route path="/chat-settings" element={<RoleRoute><ChatSettingsScreen /></RoleRoute>} />
        <Route path="/call-settings" element={<RoleRoute><CallSettingsScreen /></RoleRoute>} />
        <Route path="/get-started" element={<Navigate to="/get-started/calls" replace />} />
        <Route path="/get-started/:product" element={<RoleRoute><GetStartedIntegrate /></RoleRoute>} />
        <Route path="/get-started/:product/:kitType" element={<RoleRoute><GetStartedIntegrate /></RoleRoute>} />
        <Route path="/get-started/:product/:kitType/:sdk" element={<RoleRoute><GetStartedIntegrate /></RoleRoute>} />
        <Route path="/widget-builder/:varientId" element={<RoleRoute withLayout={false}><WidgetBuilder /></RoleRoute>} />
        <Route path="/chat-bot" element={<RoleRoute><ChatBot /></RoleRoute>} />
        <Route path="/ai-chat-bot" element={<RoleRoute><AIChatBot /></RoleRoute>} />
        <Route path="/home" element={<RoleRoute><Home /></RoleRoute>} />
        <Route path="/members" element={<RoleRoute><Members /></RoleRoute>} />
        <Route path="/profile" element={<RoleRoute><Profile /></RoleRoute>} />
        <Route path="/support" element={<RoleRoute><Support /></RoleRoute>} />
        <Route path="/plans-and-billing" element={<RoleRoute><PlansAndBilling /></RoleRoute>} />
        <Route path="/api-keys" element={<RoleRoute><ApiKeys /></RoleRoute>} />
        <Route path="/application-participants" element={<RoleRoute><ApplicationParticipants /></RoleRoute>} />
        <Route path="/application-agents" element={<RoleRoute><ApplicationAgents /></RoleRoute>} />
        <Route path="/agents-chats" element={<RoleRoute><AgentChats /></RoleRoute>} />
        <Route path="/inactive-user-requests" element={<RoleRoute><InactiveUserRequests /></RoleRoute>} />
        <Route path="/call-recordings" element={<RoleRoute><CallRecordingsScreen /></RoleRoute>} />
        <Route path="/application-settings" element={<RoleRoute><ApplicationSettings /></RoleRoute>} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="/documentation/:sectionId" element={<Documentation />} />
        <Route path="/documentation/calls/:sdk" element={<Documentation />} />
        <Route path="/documentation/calls/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/documentation/chat/:sdk" element={<Documentation />} />
        <Route path="/documentation/chat/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/documentation/schedule-consultation/:sdk" element={<Documentation />} />
        <Route path="/documentation/schedule-consultation/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/documentation/:kitType/calls/:sdk" element={<Documentation />} />
        <Route path="/documentation/:kitType/calls/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/documentation/:kitType/chat/:sdk" element={<Documentation />} />
        <Route path="/documentation/:kitType/chat/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/documentation/:kitType/schedule-consultation/:sdk" element={<Documentation />} />
        <Route path="/documentation/:kitType/schedule-consultation/:sdk/:sectionId" element={<Documentation />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/ai-employee" element={<AIEmployee />} />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
